if (!customElements.get('ewocar-discovery')) {
  customElements.define('ewocar-discovery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const listen = (node, type, handler, options = {}) => node?.addEventListener(type, handler, { ...options, signal: this.abort.signal });
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      this.paused = this.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hovered = false;
      this.focused = false;
      this.visible = true;
      const feature = this.querySelector('.ed-feature');
      listen(this.querySelector('[data-next]'), 'click', () => this.show(this.index + 1, true));
      listen(this.querySelector('[data-prev]'), 'click', () => this.show(this.index - 1, true));
      listen(this.querySelector('[data-pause]'), 'click', () => { this.paused = !this.paused; this.syncPlayback(); });
      listen(feature, 'mouseenter', () => { this.hovered = true; this.syncPlayback(); });
      listen(feature, 'mouseleave', () => { this.hovered = false; this.syncPlayback(); });
      listen(feature, 'focusin', () => { this.focused = true; this.syncPlayback(); });
      listen(feature, 'focusout', event => { if (!feature.contains(event.relatedTarget)) { this.focused = false; this.syncPlayback(); } });
      listen(document, 'visibilitychange', () => this.syncPlayback());
      let touchX = 0;
      let touchY = 0;
      listen(feature, 'touchstart', event => { touchX = event.changedTouches[0].clientX; touchY = event.changedTouches[0].clientY; }, { passive: true });
      listen(feature, 'touchend', event => { const dx = event.changedTouches[0].clientX - touchX; const dy = event.changedTouches[0].clientY - touchY; if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1), true); }, { passive: true });
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.tabs.forEach((tab, index) => {
        listen(tab, 'click', () => this.selectTab(tab));
        listen(tab, 'keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); this.selectTab(this.tabs[next]); this.tabs[next].focus(); }
        });
      });
      listen(this, 'shopify:block:select', event => { const index = this.slides.findIndex(slide => slide.contains(event.target)); if (index >= 0) this.show(index, true); });
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.syncPlayback(); });
      this.observer.observe(feature);
      this.syncPlayback();
    }
    show(next, manual = false) {
      if (!this.slides.length) return;
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.querySelector('[data-counter]').textContent = String(this.index + 1).padStart(2, '0');
      if (manual) { this.paused = true; this.querySelector('[data-announcement]').textContent = this.slides[this.index].getAttribute('aria-label'); }
      this.syncPlayback();
    }
    syncPlayback() {
      clearTimeout(this.timer);
      const button = this.querySelector('[data-pause]');
      if (button) { button.setAttribute('aria-label', this.paused ? this.dataset.play : this.dataset.pause); button.setAttribute('aria-pressed', String(this.paused)); this.querySelector('[data-play-icon]').textContent = this.paused ? '▶' : 'Ⅱ'; }
      if (!this.paused && !this.hovered && !this.focused && this.visible && !document.hidden && this.slides.length > 1) this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 7000);
    }
    selectTab(tab) {
      this.tabs.forEach(item => { const selected = item === tab; item.setAttribute('aria-selected', String(selected)); item.tabIndex = selected ? 0 : -1; });
      this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== tab.dataset.tab; });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.abort?.abort();
      this.initialized = false;
    }
  });
}
